import React from "react";
const SvgValid = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        style={{
          stroke: "none"
        }}
        fill="#00C694"
        d="M0 8a8 8 0 0016 0 8 8 0 00-8-8 8 8 0 00-8 8z"
      />
      <path
        style={{
          stroke: "#fff"
        }}
        d="M4.06 7.07l3.24 3.15 4.76-4.5"
      />
    </g>
  </svg>
);
export default SvgValid;
